"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHContainer = void 0;
class KHContainer extends Phaser.GameObjects.Container {
    /**
     * A Phaser container that allows bounds to be set.
     * @param scene Scene the container belongs to.
     * @param x x offset
     * @param y y offset
     * @param w width
     * @param h height
     * @param bg_color Color of background (hex)
     * @param bg_alpha Alpha of background (0-1)
     * @param border_width How much the background should go beyond the clipped area.
     * @param clips_to_bounds If contents outside container bounds should be masked.
     */
    constructor(scene, x, y, w, h, bg_color = null, bg_alpha = 0, border_width = 0, clips_to_bounds = false) {
        super(scene, x, y);
        this.redrawInternal(w, h, bg_color, bg_alpha, border_width, clips_to_bounds);
        scene.add.existing(this);
    }
    resize(w, h) {
        this.redrawInternal(w, h);
    }
    redrawInternal(w, h, bgColor = this.bgColor, bgAlpha = this.bgAlpha, borderWidth = this.borderWidth, clipsToBounds = this.clipsToBounds) {
        // Redraw mask
        if (w != this.c_w || h != this.c_h || clipsToBounds != this.clipsToBounds) {
            this.clearMask(true);
            if (clipsToBounds) {
                this.setMask(new Phaser.Display.Masks.BitmapMask(this.scene, this.scene.make.graphics({ fillStyle: { color: 0x0 }, add: false }).fillRect(this.x, this.y, w, h)));
            }
        }
        // Redraw background
        if (w != this.c_w || h != this.c_h || bgColor != this.bgColor || bgAlpha != this.bgAlpha) {
            if (this.bg) {
                this.bg.destroy();
                this.bg = null;
            }
            if (bgColor !== null && bgAlpha > 0) {
                this.bg = this.scene.add.rectangle(-borderWidth, -borderWidth, w + borderWidth * 2, h + borderWidth * 2, bgColor, bgAlpha).setOrigin(0).setDepth(-1);
                this.add(this.bg);
            }
        }
        this.c_w = w;
        this.c_h = h;
        this.bgColor = bgColor;
        this.bgAlpha = bgAlpha;
        this.borderWidth = borderWidth;
        this.clipsToBounds = clipsToBounds;
    }
    addImage(x, y, texture) {
        const img = this.scene.add.image(x, y, texture);
        this.add(img);
        return img;
    }
}
exports.KHContainer = KHContainer;
